export default [
  {
    url: '/',
    name: 'Forms',
    slug: 'home',
    icon: 'HomeIcon'
  }
]
